import { render } from "./ProductsSlider.vue?vue&type=template&id=2b58d05e&scoped=true"
import script from "./ProductsSlider.vue?vue&type=script&lang=js"
export * from "./ProductsSlider.vue?vue&type=script&lang=js"

import "./ProductsSlider.vue?vue&type=style&index=0&id=2b58d05e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b58d05e"]])

export default __exports__